import { MixedLineBarChartProps } from '@amzn/awsui-components-core';
import { SaSDetailsTabTableData } from './SasInterfaces';

interface SasAggregatedData {
  riskResponseGraphData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
  totalOpenRiskGraphData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
  campaignsGraphData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
  totalOpenRecommendationsGraphData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
  sasManagerMomTableData: SaSDetailsTabTableData;
}

export const aggregateSasSummaryData = (sasData: SasAggregatedData) => {
  // Aggregate SAS data for AI summary
  return {
    riskResponseGraphData: sasData.riskResponseGraphData || [],
    totalOpenRiskGraphData: sasData.totalOpenRiskGraphData || [],
    campaignsGraphData: sasData.campaignsGraphData || [],
    totalOpenRecommendationsGraphData: sasData.totalOpenRecommendationsGraphData || [],
    sasManagerMomTableData: sasData.sasManagerMomTableData || ({} as SaSDetailsTabTableData)
  };
};
